require("./bootstrap");
require("vanilla-cookieconsent");
require("./cookieconsent-init");
import "@mdi/font/css/materialdesignicons.css";
import "vanilla-cookieconsent/dist/cookieconsent.css";

window.Vue = require("vue");

import Vue from "vue";
import Vuelidate from "vuelidate";
import Vuex from "vuex";
import VueRouter from "vue-router";
import VideoBackground from "vue-responsive-video-background-player";
import VueLazyload from "vue-lazyload";
import Jwt from "jsonwebtoken";
import TypeaheadAutocomplete from "typeahead-autocomplete";

window.select2 = require("vanilla-cookieconsent");

Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(Vuelidate);

Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: "/images/error.webp",
    loading: "/images/Spinner-1s-200px.svg",
    attempt: 1,
});

Vue.use(TypeaheadAutocomplete);

const getDefaultState = () => {
    let token = localStorage.getItem("itb-spa-token-client");
    let cartCounter = localStorage.getItem("cartCounter");
    let tokenData = token ? Jwt.decode(token) : null;
    let isWelcomeMessageHidden = localStorage.getItem("isWelcomeMessageHidden");

    return {
        pageParams: {
            page_is_on_references: false,
            page_button_text: "",
            page_title: "",
            page_subtitle: "",
            page_breadcrumbs: [],
        },
        appParams: {},
        isLoggedIn: token ? true : false,
        tokenData: tokenData,
        profile: token ? tokenData.client.client : {},
        cartCounter: !!cartCounter ? cartCounter : 0,
        showCartCounter: cartCounter > 0 ? true : false,
        isWelcomeMessageHidden: isWelcomeMessageHidden,
        domainLanguage: "en",
    };
};

const store = new Vuex.Store({
    state: getDefaultState(),
    mutations: {
        setPageParams(state, payload) {
            state.pageParams = payload;
        },

        setAppParams(state, payload) {
            state.appParams = payload;
        },

        clientAuthenticate(state, payload) {
            let token = localStorage.getItem("itb-spa-token-client");

            state.isLoggedIn = token ? true : false;

            if (state.isLoggedIn) {
                state.profile = payload;
                state.tokenData = token ? Jwt.decode(token) : null;
            } else {
                state.profile = {};
            }
        },

        updateCartCounter(state, payload) {
            state.cartCounter = parseInt(state.cartCounter) + parseInt(payload);
            localStorage.setItem("cartCounter", state.cartCounter);
            if (state.cartCounter > 0) {
                state.showCartCounter = true;
            } else {
                state.showCartCounter = false;
            }
        },

        hideWelcomeMessage(state, payload) {
            state.isWelcomeMessageHidden = true;
            localStorage.setItem(
                "isWelcomeMessageHidden",
                state.isWelcomeMessageHidden
            );
        },

        resetState(state) {
            state.isLoggedIn = false;
            state.tokenData = null;
            state.profile = {};
            state.updatedProfile = {};
            state.showCartCounter = false;
            state.cartCounter = 0;
            state.isWelcomeMessageHidden = false;
            localStorage.setItem("cartCounter", 0);
            localStorage.removeItem("newClientData");
            localStorage.removeItem("isWelcomeMessageHidden");
        },
        resetCartCounter(state) {
            state.cartCounter = 0;
            localStorage.setItem("cartCounter", 0);
        },

        setLanguage(state, payload) {
            state.domainLanguage = payload;
        },
    },
    actions: {
        async setAppParams(state) {
            await axios
                .get("/getAppParams")
                .then((response) => {
                    state.commit("setAppParams", response.data);
                })
                .catch((error) => {
                    console.log(error.response.data);
                });
        },

        setPageParams(state, payload) {
            state.commit("setPageParams", payload);
        },

        updateCartCounter(state, payload) {
            state.commit("updateCartCounter", payload);
        },

        clientAuthenticate(context, payload) {
            context.commit("clientAuthenticate", payload);
        },

        resetState(context) {
            context.commit("resetState");
        },
        resetCartCounter(context) {
            context.commit("resetCartCounter");
        },

        hideWelcomeMessage(context) {
            context.commit("hideWelcomeMessage");
        },

        setLanguage(context, payload) {
            context.commit("setLanguage", payload);
        },
    },
    modules: {},
    getters: {
        getAppParams: (state) => state.appParams,
        getPageParams: (state) => state.pageParams,
        getClientLogged: (state) => state.isLoggedIn,
        getClientProfile: (state) => state.profile,
        getCartCounter: (state) => state.cartCounter,
        getShowCartCounter: (state) => state.showCartCounter,
        getWelcomeMessageHidden: (state) => state.isWelcomeMessageHidden,
        getDomainLanguage: (state) => state.domainLanguage,
    },
});

Vue.component(
    "app-container",
    require("./frontend/views/AppContainer.vue").default
);
Vue.component(
    "insta-posts",
    require("./frontend/components/InstagramPosts.vue").default
);
Vue.component(
    "hero-cards",
    require("./frontend/components/HeroCards.vue").default
);
Vue.component("video-background", VideoBackground);
Vue.component(
    "carousel",
    require("./frontend/components/Carousel.vue").default
);

import Home from "./frontend/views/Home.vue";
import Graphics from "./frontend/views/Graphics.vue";
import GraphicsByCategory from "./frontend/views/GraphicsByCategory.vue";
import GraphicsByCategorySubcategory from "./frontend/views/GraphicsByCategory.vue";
import GraphicDetail from "./frontend/views/GraphicDetail.vue";
import RealizationDetail from "./frontend/views/RealizationDetail.vue";
import Products2D from "./frontend/views/Products2D.vue";
import Products3D from "./frontend/views/Products3D.vue";
import OtherProducts from "./frontend/views/OtherProducts.vue";
import OtherProductDetail from "./frontend/views/OtherProductDetail.vue";
import OurService from "./frontend/views/OurService.vue";
import Contact from "./frontend/views/Contact.vue";
import Download from "./frontend/views/Download.vue";
import Cart from "./frontend/views/Cart.vue";
import SavedCarts from "./frontend/views/SavedCarts.vue";
import SavedCart from "./frontend/views/SavedCart.vue";
import SavedOrder from "./frontend/views/SavedOrder.vue";
import Addresses from "./frontend/views/Addresses.vue";
import PrivacyPolicy from "./frontend/views/PrivacyPolicy.vue";
import CookiesPolicy from "./frontend/views/CookiesPolicy.vue";
import OtherProductDetailSubproduct from "./frontend/views/OtherProductDetailSubproduct.vue";
import Inspirations from "./frontend/views/Inspirations.vue";

const routes = [
    {
        path: "/",
        name: "home",
        component: Home,
    },
    {
        path: "/choose-the-graphic",
        name: "graphics",
        component: Graphics,
    },
    {
        path: "/choose-the-graphic/:categoryAlias",
        name: "graphicsByCategory",
        component: GraphicsByCategory,
    },
    {
        path: "/choose-the-graphic/:categoryAlias/:subcategoryAlias",
        name: "graphicsByCategorySubcategory",
        component: GraphicsByCategorySubcategory,
    },
    {
        path: "/choose-the-graphic/:categoryAlias/:subcategoryAlias/:subcategory2Alias/:graphicAlias",
        name: "graphicDetail",
        component: GraphicDetail,
    },

    {
        path: "/2d-products",
        name: "products2D",
        component: Products2D,
    },
    {
        path: "/2d-products/realizations/:realizationAlias",
        name: "realizationDetail2D",
        component: RealizationDetail,
    },
    {
        path: "/3d-products",
        name: "products3D",
        component: Products3D,
    },
    {
        path: "/3d-products/realizations/:realizationAlias",
        name: "realizationDetail3D",
        component: RealizationDetail,
    },
    {
        path: "/other-products",
        name: "otherProducts",
        component: OtherProducts,
    },
    {
        path: "/other-products/:productAlias",
        name: "otherProductDetail",
        component: OtherProductDetail,
    },
    {
        path: "/other-products/:productAlias/:subproduct",
        name: "otherProductDetailSubproduct",
        component: OtherProductDetailSubproduct,
    },

    {
        path: "/other-products-realizations/:categoryAlias/:realizationAlias",
        name: "realizationDetailOtherProducts",
        component: RealizationDetail,
    },

    {
        path: "/our-service",
        name: "ourService",
        component: OurService,
    },
    {
        path: "/contact",
        name: "contact",
        component: Contact,
    },
    {
        path: "/download",
        name: "download",
        component: Download,
    },
    {
        path: "/cart",
        name: "cart",
        component: Cart,
    },
    {
        path: "/saved-carts",
        name: "savedCarts",
        component: SavedCarts,
    },
    {
        path: "/saved-carts/carts/:cartNumber",
        name: "savedCart",
        component: SavedCart,
    },
    {
        path: "/saved-carts/orders/:orderNumber",
        name: "savedOrder",
        component: SavedOrder,
    },
    {
        path: "/settings",
        name: "address",
        component: Addresses,
    },
    {
        path: "/privacy-policy",
        name: "privacyPolicy",
        component: PrivacyPolicy,
    },
    {
        path: "/cookies-policy",
        name: "cookiesPolicy",
        component: CookiesPolicy,
    },
    { path: "/saved-carts/carts", redirect: "/saved-carts" },
    { path: "/saved-carts/orders", redirect: "/saved-carts" },
    {
        path: "/2d-products/realizations",
        redirect: { path: "/2d-products", hash: "#itb-h2-inspirations" },
    },
    {
        path: "/3d-products/realizations",
        redirect: { path: "/3d-products", hash: "#itb-h2-inspirations" },
    },
    {
        path: "/other-products-realizations/:categoryAlias",
        redirect: (to) => {
            return {
                path: "/other-products/:productAlias",
                params: { productAlias: to.params.categoryAlias },
            };
        },
    },
    {
        path: "/other-products-realizations",
        redirect: { path: "/other-products" },
    },
    {
        path: "/inspirations",
        name: "inspirations",
        component: Inspirations,
    },
];

const router = new VueRouter({
    mode: "history",
    routes,
    scrollBehavior(to, from, savedPosition) {
        let yTop = 0;

        if (to.params.savedPosition) return to.params.savedPosition;

        if (to.params.scrollToElementId) {
            let elem = document.getElementById(to.params.scrollToElementId);
            yTop = elem.offsetTop - 100;
        }

        return { x: 0, y: yTop };
    },
});

// Allows calling methods from other component with no parent-child relationship
Vue.prototype.$eventBus = new Vue();

const app = new Vue({
    el: "#app",
    router,
    store,
});
